import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AuthModule } from './auth/auth.module';
import { DynamicUiModule } from './dynamic-ui/dynamic-ui.module';

import { AppComponent } from './app/views/app/app.component';
import { WithHeaderComponent } from './app/views/with-header/with-header.component';
import { WithSimpleHeaderComponent } from './app/views/with-simple-header/with-simple-header.component';
import { WithoutHeaderComponent } from './app/views/without-header/without-header.component';
import { AppRoutingModule } from "./app-routing.module";
import { AppFacade } from './app/store/app.facade';
import { HeaderComponent } from './app/controls/header/header.component';
import { SimpleHeaderComponent } from './app/controls/simple-header/simple-header.component';
import { HeaderMenuComponent } from './app/controls/header-menu/header-menu.component';

import { HomeComponent } from './app/views/home/home.component';
import { AppEffects } from './app/store/app.effects';
import { appReducer } from './app/store/app.reducer';
import { NotifierComponent } from './app/controls/notifier/notifier.component';
// Material
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from "@angular/material/divider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTreeModule } from "@angular/material/tree";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { DynamicComponent } from './dynamic-ui/views/dynamic/dynamic.component';
import { SingleViewComponent } from './dynamic-ui/views/single-view/single-view.component';
import { PresentationViewComponent } from './dynamic-ui/views/presentation-view/presentation-view.component';
// Shared components
import { ConfirmDialogComponent } from './app/controls/confirm-dialog/confirm-dialog.component';

@NgModule({ declarations: [
        AppComponent,
        WithHeaderComponent,
        WithSimpleHeaderComponent,
        WithoutHeaderComponent,
        HeaderComponent,
        SimpleHeaderComponent,
        HeaderMenuComponent,
        HomeComponent,
        NotifierComponent,
        DynamicComponent,
        SingleViewComponent,
        PresentationViewComponent,
        ConfirmDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        // Material
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatDividerModule,
        MatSnackBarModule,
        MatTableModule,
        MatTreeModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        // ngrx
        StoreModule.forRoot({
            app: appReducer
        }, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
                strictStateSerializability: true,
                strictActionSerializability: true
            }
        }),
        EffectsModule.forRoot(AppEffects),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode(), connectInZone: true }),
        AuthModule,
        AppRoutingModule,
        DynamicUiModule], providers: [
        AppFacade,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
